// extracted by mini-css-extract-plugin
export var change = "_3t-1";
export var changeList = "_3t-0";
export var changePath = "_3t-2";
export var diffArrow = "_3t-5";
export var diffRow = "_3t-3";
export var diffValue = "_3t-4";
export var error = "_3t-8";
export var notice = "_3t-9";
export var result = "_3t-6";
export var success = "_3t-7";